var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_59",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "40.858", y1: "87.667", x2: "59.199", y2: "87.667" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "50.028", y1: "87.06", x2: "50.028", y2: "77.442" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m34.894,14.333h30.211c.573,0,1.014.508.932,1.076l-.405,2.808c-.35,2.426-.701,4.853-1.051,7.279-.483,3.346-.966,6.692-1.449,10.038,0,.714-.215,1.49-.317,2.198,0,.712-.215,1.487-.316,2.193-.106.731-.211,1.462-.316,2.194-.216,1.504-.432,3.009-.648,4.513-.441,3.07-.882,6.14-1.323,9.21-.631,4.391-1.27,8.78-1.904,13.17-.193,1.34-.313,2.711-.942,3.935-.961,1.867-2.632,3.329-4.613,4.027-.883.311-1.817.469-2.753.469-2.107,0-4.164-.819-5.694-2.269-1.955-1.852-2.335-4.165-2.691-6.697-.431-3.066-.867-6.131-1.309-9.196-.873-6.064-1.762-12.125-2.637-18.188l-.106-.734-1.501-10.404c-.412-2.855-.824-5.709-1.236-8.564-.248-1.72-.496-3.44-.745-5.161-.04-.274-.079-.548-.119-.822-.082-.568.358-1.076.932-1.076Z",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "42.334",
          y: "25.319",
          width: "9.13",
          height: "9.13",
          rx: "1",
          ry: "1",
          transform: "translate(34.868 -24.41) rotate(45)",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "45.236",
          y: "48.849",
          width: "9.13",
          height: "9.13",
          rx: "1",
          ry: "1",
          transform: "translate(24.023 -14.914) rotate(22.326)",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "50", y1: "25.958", x2: "64.513", y2: "25.958" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "35.551", y1: "25.958", x2: "43.975", y2: "25.958" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }